import {createFeatureSelector, createSelector} from "@ngrx/store";
import {Task} from "protractor/built/taskScheduler";

export interface UiState {
  isLoading: boolean;
}

export const INITIAL_UI_STATE: UiState = {
  isLoading: true,
};

const uiStateFeatureSelector = createFeatureSelector<UiState>("uiState");
export const isLoadingSelector = createSelector(uiStateFeatureSelector, (uiState) => uiState.isLoading);

